/**
 * Component that injects empty stylesheets to prevent Marketo from loading default styles.
 * This is intentional to override Marketo's default styling with our custom styles.
 */
export const MarketoStylesheets = () => {
  return (
    <>
      {/* eslint-disable-next-line @next/next/no-css-tags */}
      <link
        id="mktoForms2BaseStyle"
        rel="stylesheet"
        type="text/css"
        href="data:text/css;base64,LyogRW1wdHkgKi8="
      />
      {/* eslint-disable-next-line @next/next/no-css-tags */}
      <link
        id="mktoForms2ThemeStyle"
        rel="stylesheet"
        type="text/css"
        href="data:text/css;base64,LyogRW1wdHkgKi8="
      />
    </>
  );
};
